// src/App.js

import React from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";

/*=========================================================
    Layout
=========================================================*/

import Layout from "./components/layout/Layout";

/*=========================================================
    Pages publiques
=========================================================*/

import HomePage from "./pages/HomePage";
import Login from "./pages/login/Login";
import Register from "./pages/login/Register";
import ForgotPassword from "./pages/login/ForgotPassword";
import VerifyEmail from "./pages/login/VerifyEmail";


/*=========================================================
    Profil
=========================================================*/

import Profile from "./pages/Profile";
import UpdateProfessionnel from "./pages/UpdateProfessionnel";

/*=========================================================
    Consultants
=========================================================*/

import ConsultantSearchPage from "./pages/ConsultantSearchPage";

/*=========================================================
    Consultations
=========================================================*/

import ConsultationRequestPage from "./pages/consultationrequest/ConsultationRequestPage";


/*=========================================================
    Forum
=========================================================*/

import ForumPage from "./pages/forum/ForumPage";
import ForumConversation from "./pages/forum/ForumConversation";

/*=========================================================
    Administration
=========================================================*/

import Administration from "./pages/Administration";

//activityPro
import AddActivityProf from "./pages/activityprof/AddActivityProf"
import ListActivityProf  from "./pages/activityprof/ListActivityProf";
import UpdateActivityProf  from "./pages/activityprof/UpdateActivityProf";
import DetailActivityProf  from "./pages/activityprof/DetailActivityProf";

//ActivityType
import AddActivityType from "./pages/activitytype/AddActivityType";
import ListActivityType from "./pages/activitytype/ListActivityType";
import UpdateActivityType from "./pages/activitytype/UpdateActivityType";
import DetailActivityType from "./pages/activitytype/DetailActivityType";

//Statut
import AddStatut from "./pages/statut/AddStatut";
import ListStatut from "./pages/statut/ListStatut";
import UpdateStatut from "./pages/statut/UpdateStatut";
import DetailStatut from "./pages/statut/DetailStatut";

//Specialite
import AddSpecialite from "./pages/specialite/AddSpecialite";
import ListSpecialite  from "./pages/specialite/ListSpecialite";
import UpdateSpecialite from "./pages/specialite/UpdateSpecialite";
import DetailSpecialite from "./pages/specialite/DetailSpecialite";


//Wilaya
import AddWilaya from "./pages/wilaya/AddWilaya";
import ListWilaya from "./pages/wilaya/ListWilaya";
import UpdateWilaya from "./pages/wilaya/UpdateWilaya";
import DetailWilaya from "./pages/wilaya/DetailWilaya";


//commune
import AddCommune from "./pages/commune/AddCommune";
import ListCommune from "./pages/commune/ListCommune";
import UpdateCommune from "./pages/commune/UpdateCommune";
import DetailCommune from "./pages/commune/DetailCommune";




//UserApp
import ListUserApp from "./pages/userapp/ListUserApp";
import UpdateUserApp from "./pages/userapp/UpdateUserApp";
import DetailUserApp from "./pages/userapp/DetailUserApp";

/*=========================================================
    Application
=========================================================*/

export default function App() {

    return (

        <AuthProvider>

            <LanguageProvider>

                <BrowserRouter>

                    <ToastContainer
                        position="bottom-right"
                        autoClose={2000}
                        newestOnTop
                        closeOnClick
                        pauseOnHover
                        theme="colored"
                    />

                    <Routes>

                        <Route
                            path="/"
                            element={<Layout />}
                        >

                            <Route
                                index
                                element={<HomePage />}
                            />

                            <Route
                                path="login"
                                element={<Login />}
                            />

                            <Route
                                path="register"
                                element={<Register />}
                            />

                            <Route
                                path="forgot-password"
                                element={<ForgotPassword />}
                            />

                            <Route
                                path="verify-email"
                                element={<VerifyEmail />}
                            />

                            <Route
                                path="profile/:id"
                                element={<Profile />}
                            />

                            <Route
                                path="updateprofessionnel/:id"
                                element={<UpdateProfessionnel />}
                            />

                            <Route
                                path="searchconsultant"
                                element={<ConsultantSearchPage />}
                            />

                            <Route
                                path="consultationrequest"
                                element={<ConsultationRequestPage />}
                            />

                            <Route
                                path="forum"
                                element={<ForumPage />}
                            />

                            <Route
                                path="forum/conversation/:id"
                                element={<ForumConversation />}
                            />

                            <Route
                                path="administration"
                                element={<Administration />}
                            />

{/*Activité Profesionnelle*/}


<Route
    path="addactivityprof"
    element={<AddActivityProf />}
/>

<Route
    path="listactivityprof"
    element={<ListActivityProf />}
/>

<Route
    path="updateactivityprof/:id"
    element={<UpdateActivityProf />}
/>

              
              {/*activityType*/}
              <Route path="/listactivitytype" element={<ListActivityType />} />
              <Route path="/addactivitytype"  element={<AddActivityType />}  />
              <Route path="/updateactivitytype/:id"   element={<UpdateActivityType />}  />
              <Route path="/detailactivitytype"  element={<DetailActivityType/>}/>

              {/*Statut*/}
              <Route path="/liststatut" element={<ListStatut />} />
              <Route path="/addstatut"  element={<AddStatut />}   />
              <Route path="/updatestatut/:id"    element={<UpdateStatut />}    />
              <Route path="/detailstatut"  element={<DetailStatut />}  />

              {/*Specialite*/}
              <Route path="/listspecialite" element={<ListSpecialite />} />
              <Route path="/addspecialite"  element={<AddSpecialite />}   />
              <Route path="/updatespecialite/:id"    element={<UpdateSpecialite />}    />
              <Route path="/detailspecialite"  element={<DetailSpecialite />}  />


              {/*Wilaya*/}
              <Route path="/listwilaya" element={<ListWilaya />} />
              <Route path="/addwilaya" element={<AddWilaya />} />
              <Route path="/updatewilaya/:id"  element={<UpdateWilaya />}  />
              <Route path="/detailwilaya/:id"  element={<DetailWilaya/>}  />

              
              {/* Commune */}
              <Route path="/listcommune" element={<ListCommune />} />
              <Route path="/addcommune" element={<AddCommune />} />
              <Route path="/updatecommune/:id"  element={<UpdateCommune />} />
              <Route path="/detailcommune/:id"  element={<DetailCommune/>}  />

            {/* User App */}
              <Route path="/listuserapp" element={<ListUserApp/>} />
              <Route path="/updateuserapp/:id"  element={<UpdateUserApp />} />
              <Route path="/detailuserapp/:id"  element={<DetailUserApp/>}  />



                            {/* toutes les autres routes */}

                        </Route>

                    </Routes>

                </BrowserRouter>

            </LanguageProvider>

        </AuthProvider>

    );

}